import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs: {
  question: string;
  answer: React.ReactNode;
}[] = [{
  question: '¿Funciona con cualquier marca de freidora?',
  answer: 'Sí, las recetas están pensadas para cualquier freidora de aire, sin importar la marca o el tamaño.'
}, {
  question: '¿Los ingredientes se consiguen en Argentina?',
  answer: 'Todos los ingredientes son comunes y los encontrás en cualquier supermercado o verdulería de Argentina.'
}, {
  question: '¿Cómo recibo el recetario?',
  answer: 'Inmediatamente después del pago recibís un email con el link de descarga. Es un archivo PDF que podés ver en cualquier dispositivo.'
}, {
  question: '¿Sirve si soy principiante?',
  answer: 'Totalmente. Cada receta tiene instrucciones paso a paso, con tiempos y temperaturas exactas. No necesitás experiencia previa.'
}, {
  question: '¿En qué formato viene el recetario?',
  answer: 'El recetario viene en formato PDF, que podés abrir en cualquier dispositivo: celular, tablet, computadora o Smart TV. No necesitás ninguna app especial, con el lector de PDF que ya tenés es suficiente.'
}, {
  question: '¿Puedo imprimirlo?',
  answer: 'Sí, totalmente. El archivo está optimizado para impresión. Podés imprimirlo completo o solo las recetas que más uses y armarte tu propio recetario físico.'
}, {
  question: '¿Funciona en iPhone o iPad?',
  answer: 'Sí, funciona perfecto en todos los dispositivos Apple. El PDF se abre directo desde el email que recibís al comprar, sin pasos complicados.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full py-16 md:py-24 px-6 bg-background" data-id="element-135">
      <div className="max-w-[700px] mx-auto" data-id="element-136">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-3xl md:text-4xl font-serif mb-10 text-center text-charcoal" data-id="element-137">
          Preguntas frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-138">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white border border-surface rounded-2xl overflow-hidden shadow-sm" data-id="element-139">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-140">
                  <span className="font-medium text-charcoal text-lg pr-4" data-id="element-141">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 180 : 0
              }} transition={{
                duration: 0.2
              }} className="text-primary flex-shrink-0" data-id="element-142">
                    <ChevronDown className="w-5 h-5" data-id="element-143" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-144">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-145">
                      <div className="px-6 pb-5 text-charcoal/80 leading-relaxed" data-id="element-146">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center" data-id="element-147">
          <h3 className="text-2xl font-serif text-charcoal mb-6" data-id="element-148">
            ¿Listo para cocinar?
          </h3>
          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => {
          window.location.href = 'https://valordigital.store/cart/46518849142973:1';
        }} className="w-full md:w-auto bg-primary hover:bg-primary-hover text-white font-bold uppercase tracking-wider py-4 px-8 rounded-xl shadow-soft transition-colors text-base" data-id="element-149">
            Descargar mi recetario →
          </motion.button>
        </motion.div>
      </div>
    </section>;
}